import {Box, Flex} from '@mantine/core';
import React, {useRef} from 'react';

import useEscapeToClosePreview from 'external-files/useEscapeToClosePreview';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY, WHITE} from 'ui-library/Colors';

interface NoteLinkedEmbeddingPreviewProps {
  children: React.ReactNode;
  onClose: () => void;
}
export default function NoteLinkedEmbeddingPreview({
  children,
  onClose,
}: NoteLinkedEmbeddingPreviewProps): JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);
  // Note: Escape  will close previews if focus is _inside_ this component. Plotly charts involve an
  // iframe, so if the user interacts with a Plotly chart by dragging an axis, our hotkey will not
  // be active. e2e coverage means using postMessage between ChartRenderer.tsx and
  // SecurePlotlyChart.
  useEscapeToClosePreview(onClose, containerRef);

  return (
    <Flex ref={containerRef} direction="column" w="100%" h="100%">
      <Box sx={{flex: '0 0 auto', borderBottom: `1px solid ${GRAY}`, background: WHITE}} px={12} py={5}>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          size={ButtonSize.SMALL}
          icon="cross-thick"
          text="Close preview"
          onClick={onClose}
        />
      </Box>
      {/*
        Fill the space left by the header. `min-height: 0` overrides the flex default of
        `min-height: auto` so this item can shrink below the SVG's intrinsic height, giving children
        a definite height to resolve `100%`.
      */}
      <Box sx={{flex: '1 1 0', minHeight: 0}}>{children}</Box>
    </Flex>
  );
}
